module.exports = __webpack_public_path__ + "e4ab4e978daf02fe40a6ea183febb56a.svg";